import type { InputModelParsingError, InputModelParsingErrorMessageMap } from ".";
import { INPUT_MODEL_PARSING_ERROR } from ".";
import t from "../../../../i18n";
import { FILE_PARSING_ERROR } from "../../common/file";

/**
 * @description Error messages that can be presented to the user by the input model parser.
 */
const InputModelParsingErrorMessages: InputModelParsingErrorMessageMap = {
  [FILE_PARSING_ERROR.FILE_EMPTY]: () =>
    t("setup.diagnosis.observable.import_observables.error.empty_file"),
  [FILE_PARSING_ERROR.FILE_SIZE_LIMIT_EXCEEDED]: () =>
    t("setup.diagnosis.observable.import_observables.error.file_size_limit_exceeded"),
  [FILE_PARSING_ERROR.FILE_INVALID_TYPE]: () =>
    t("setup.simulation.input_model.error.file_invalid_type"),
  [INPUT_MODEL_PARSING_ERROR.FILE_INVALID_CONTENT]: () =>
    t("setup.simulation.input_model.error.file_invalid_content"),
  [INPUT_MODEL_PARSING_ERROR.DATA_FILE_EMPTY]: () =>
    t("setup.simulation.input_model.error.data_file_empty"),
  [INPUT_MODEL_PARSING_ERROR.DATA_QUANTITY_DUPLICATED]: errorData =>
    t("setup.simulation.input_model.error.data_quantity_duplicated", errorData.value || ""),
  [INPUT_MODEL_PARSING_ERROR.DATA_QUANTITY_NAME_EMPTY]: () =>
    t("setup.simulation.input_model.error.name.empty"),
  [INPUT_MODEL_PARSING_ERROR.DATA_QUANTITY_NAME_NOT_ALLOWED]: errorData =>
    t("setup.simulation.input_model.error.data_quantity_name_not_allowed", errorData.value || ""),
  [INPUT_MODEL_PARSING_ERROR.DATA_ORDER_EXTERNAL_GAP_INVALID]: errorData =>
    t("setup.simulation.input_model.error.order_external_gap.invalid", errorData.value || ""),
  [INPUT_MODEL_PARSING_ERROR.DATA_ORDER_EXTERNAL_GAP_NOT_ASCENDING]: () =>
    t("setup.simulation.input_model.error.order_external_gap.ascending"),
  [INPUT_MODEL_PARSING_ERROR.DATA_REFERENCE_VALUE_INVALID]: errorData =>
    t("setup.simulation.input_model.error.reference_value.invalid", errorData.value || ""),
  [INPUT_MODEL_PARSING_ERROR.DATA_EXTERNAL_GAP_INVALID]: errorData =>
    t("setup.simulation.input_model.import.error.external_gap.invalid", errorData.value || ""),
  [INPUT_MODEL_PARSING_ERROR.DATA_INPUT_MODEL_NAME_TOO_LONG]: errorData =>
    t("setup.quantity.import.error.data_input_model_name_too_long", errorData.value || ""),
  [INPUT_MODEL_PARSING_ERROR.HAS_TIME_FUNCTION_DEPENDENCY]: () =>
    t("setup.simulation.input_model.error.has_time_function_dependency"),
};

/**
 * @description Get error message from error kind.
 * @param error InputModelParsingError
 * @returns Translated error message.
 */
export const getInputModelParsingErrorMessage = (error: InputModelParsingError) => {
  const errorMessage = InputModelParsingErrorMessages[error.kind];
  return errorMessage ? errorMessage(error.data) : "Unknown error";
};
